import { useState } from "react";
import useTranslation from "../../hooks/useTranslation";
import { SurveyRecipient } from "../../types/survey";
import { Button } from "../ui/Button/Button";
import { Input } from "../ui/Input/Input";
import { Typography } from "../ui/Typography/Typography";
import "./SurveyRecipientInput.scss";

export interface SurveyRecipientInputProps {
  recipientList: SurveyRecipient[];
  handleAddRecipients: (recipients: SurveyRecipient[]) => boolean;
  setError: (error: string) => void;
  submitSuccess: string;
  setSubmitSuccess: (error: string) => void;
}
export const SurveyRecipientInput = ({
  recipientList,
  handleAddRecipients,
  setError,
  submitSuccess,
  setSubmitSuccess,
}: SurveyRecipientInputProps) => {
  const { t } = useTranslation("surveyLaunchPage");
  const [inputEmail, setInputEmail] = useState<string>("");
  const [inputPhoneNumber, setInputPhoneNumber] = useState<string>("");
  const [info, setInfo] = useState<string>("");

  const validateAndAddRecipient = (email: string, phone_number: string) => {
    const newRecipient: SurveyRecipient = {
      email: email.trim(),
      phone_number: phone_number.trim() || undefined,
    };

    return handleAddRecipients([newRecipient]);
  };

  const handleEmailChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setInputEmail(ev.target.value);
    setError("");
    setInfo("");
  };

  const handlePhoneNumberChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setInputPhoneNumber(ev.target.value);
  };

  const handleAdd = () => {
    const email = inputEmail.trim();

    if (email) {
      if (validateAndAddRecipient(email, inputPhoneNumber)) {
        setInputEmail("");
        setInputPhoneNumber("");
        setInfo(t("shareLink.added", { value: email }) || "");
        setSubmitSuccess("");
      }
    }
  };

  return (
    <div className="SurveyRecipientInput">
      <div className="SurveyRecipientInput__formWrapper">
        <div className="SurveyRecipientInput__inputWrapper">
          <Input
            value={inputEmail}
            onChange={handleEmailChange}
            label={t("shareLink.emailLabel") || ""}
            size="small"
            required
            data-testid="email-input"
          />
          <Input
            value={inputPhoneNumber}
            onChange={handlePhoneNumberChange}
            label={t("shareLink.phoneNumberLabel") || ""}
            size="small"
            data-testid="phone-input"
          />
        </div>

        <Button
          variant="contained"
          color="secondary"
          small
          onClick={handleAdd}
          data-testid="add-recipient-button"
        >
          {t("shareLink.add")}
        </Button>
      </div>
      {!submitSuccess && info && (
        <Typography desktop="caption" data-testid="success-message">
          {info}
        </Typography>
      )}
    </div>
  );
};
